import React from "react";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import AvailabilityManager from "../../../components/AvailabilityManager";
import { useSetup } from "../hooks/useSetup";

import {
  KoraxOnboardingShell,
  KoraxOnboardingContent,
  KoraxOnboardingFooter
} from "../../../components/KoraxUI/Onboarding";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    maxWidth: 1080
  },

  info: {
    marginTop: 16,
    padding: 14,
    borderRadius: 12,
    color: theme.palette.text.secondary,
    background: "rgba(21,94,239,.06)"
  }
}));

export default function SchedulingAvailabilityStep() {
  const classes = useStyles();
  const { nextStep, previousStep } = useSetup();

  return (
    <KoraxOnboardingShell step={7} totalSteps={10}>
      <KoraxOnboardingContent
        eyebrow="Horários de atendimento"
        title="Quando cada profissional está disponível?"
        description="Selecione um profissional e configure os dias, horários de atendimento e intervalos."
      >
        <div className={classes.container}>
          <AvailabilityManager />

          <div className={classes.info}>
            <Typography variant="body2">
              A Korax usará essas disponibilidades para sugerir horários compatíveis durante as conversas.
            </Typography>
          </div>
        </div>
      </KoraxOnboardingContent>

      <KoraxOnboardingFooter
        onBack={previousStep}
        onNext={nextStep}
        nextLabel="Treinar minha IA"
      />
    </KoraxOnboardingShell>
  );
}
